module.exports = __webpack_public_path__ + "img/thumbnail_AfricanPenguin_m_albino.de89bec3.png";